import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ModalCloseButton,
  RootDrawerToggle,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { CustomerRootParamList } from "../../../../types";
import { useListFilter } from "../../../../utilities/list-filter";
import { ListFilterProvider } from "../../../../utilities/list-filter/use-list-filter-context";
import { defaultCustomerFilterValues } from "../../common";
import { CustomerFilterValues } from "../../types";
import { CustomerListFilterRootScreen } from "../CustomerListFilterRootScreen";
import { CustomersListScreen } from "../CustomersListScreen";
import { CreateCustomerScreen } from "../CreateCustomerScreen";
import { EditCustomerScreen } from "../EditCustomerScreen";
import { SaleScreen } from "../../../sales/screens/SaleScreen";

export type CustomersRootScreenProps = StackScreenProps<
  any,
  "CustomersRootScreen"
>;

export const CustomersRootScreen = (_props: CustomersRootScreenProps) => {
  const Drawer = createStackHeaderNavigator<CustomerRootParamList>();

  const filterContext = useListFilter<CustomerFilterValues>({
    defaultValues: defaultCustomerFilterValues,
  });

  return (
    <ListFilterProvider {...filterContext}>
      <Drawer.Navigator
        screenOptions={{
          animationEnabled: true,
          headerStyle: {
            backgroundColor: "transparent",
          },
          headerBackgroundContainerStyle: {
            backgroundColor: "transparent",
          },
        }}
      >
        <Drawer.Group
          screenOptions={{
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerLeft: () => <RootDrawerToggle />,
          }}
        >
          <Drawer.Screen
            name="CustomerListScreen"
            component={CustomersListScreen}

          />
          <Drawer.Screen
            name="EditCustomerScreen"
            component={EditCustomerScreen}
            options={{
              headerTitle: "",
              headerLeft: () => <ModalCloseButton type="Back" />,
            }}
          />
          <Drawer.Screen
            name="SaleScreen"
            component={SaleScreen}
            options={{
              headerTitle: "",
              headerLeft: () => <ModalCloseButton type="Back" />,
            }}
          />
        </Drawer.Group>
        <Drawer.Group
          screenOptions={{
            presentation: "modal",
            headerLeft: () => <ModalCloseButton type="Close" />,
            headerTitle: "",
          }}
        >
          <Drawer.Screen
            name="CreateCustomerScreen"
            component={CreateCustomerScreen}
          />
        </Drawer.Group>
        <Drawer.Group
          screenOptions={{
            headerShown: false,
            presentation: "modal",
          }}
        >
          <Drawer.Screen
            name="CustomerListFilterRootScreen"
            component={CustomerListFilterRootScreen}
          />
        </Drawer.Group>
      </Drawer.Navigator>
    </ListFilterProvider>
  );
};
